import metadata from './metadata.schema';
import { validationMessages } from './validationMessages.schema';

export default {
  type: 'object',
  properties: {
    id: {
      type: 'number'
    },
    name: {
      title: 'Nazwa',
      type: 'string',
      fieldRequired: true
    },
    description: {
      title: 'Opis',
      type: 'string',
      fieldRequired: false
    },
    order: {
      title: 'Kolejność',
      type: 'number',
      fieldRequired: true
    },
    mediaId: {
      title: 'Id pliku',
      type: 'number',
      fieldRequired: true
    },
    entityType: {
      title: 'Typ encji',
      type: 'string',
      fieldRequired: true
    },
    entityId: {
      title: 'Id encji',
      type: 'string',
      fieldRequired: true
    },
    type: {
      title: 'Typ załącznika',
      type: 'string',
      fieldRequired: false
    },
    metadata,
    edit: {
      type: 'boolean',
      computed: true
    },
    viewId: {
      type: 'number'
    },
    checked: {
      type: 'boolean',
      computed: true
    }
  },
  allOf: [validationMessages]
};
